export default __webpack_public_path__ + "static/media/041-cornice.8fe006d6.svg";